module.exports = __webpack_public_path__ + "static/prestashop_logo_vertical-17d6f318ab9cfb90e4627134ba46b45d.png";